import { useEffect, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { resolveCrmOrganizationId } from "src-next/modules/crm-clinical/communications/helpers/resolveCrmOrganizationId";
import { hasActiveMetaWhatsAppConnection } from "src-next/modules/crm-clinical/setup/services/disconnectMetaOnFluxZapExtensionDeactivated";

export interface FluxZapDeactivationNoticeProps {
  organizationId?: string | null;
}

export function FluxZapDeactivationNotice({
  organizationId,
}: FluxZapDeactivationNoticeProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasActiveMeta, setHasActiveMeta] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setIsLoading(true);
      try {
        const active = await hasActiveMetaWhatsAppConnection({
          organizationId: resolveCrmOrganizationId(organizationId),
        });
        if (!cancelled) setHasActiveMeta(active);
      } catch {
        if (!cancelled) setHasActiveMeta(false);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  if (isLoading) {
    return (
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
        <CircularProgress size={18} />
        <Typography variant="body2" color="text.secondary">
          Verificando canal WhatsApp...
        </Typography>
      </Stack>
    );
  }

  if (hasActiveMeta) {
    return (
      <Alert
        severity="warning"
        icon={<WhatsAppIcon fontSize="inherit" />}
        sx={{ textAlign: "left", width: "100%" }}
      >
        <AlertTitle sx={{ fontWeight: 700 }}>
          Conexão Meta será desativada
        </AlertTitle>
        Sua organização usa hoje o plano de conexão{" "}
        <strong>WhatsApp Business (Meta)</strong>. Ao cancelar a extensão FluxZap,
        essa vinculação será encerrada automaticamente e o envio de mensagens
        voltará para o <strong>número padrão Fluxmed</strong>, utilizando os{" "}
        <strong>pacotes de mensagens</strong> contratados nesse canal.
      </Alert>
    );
  }

  return (
    <Typography variant="body1" align="center" color="text.secondary">
      Ao cancelar a extensão FluxZap, recursos que dependem da vinculação com a
      Meta deixarão de estar disponíveis. O envio pelo número padrão Fluxmed,
      com pacotes de mensagens, permanece disponível.
    </Typography>
  );
}
